import React, { useEffect } from 'react';
import { API } from 'aws-amplify';

const Download = ({ match }) => {

  useEffect(() => {
    API.get('api',`/files/${match.params.id}`).then(
      resp => {
        window.location.replace(resp.url);
      },
      (err) => {
        console.log(err.response)
        alert(err.response.data.message);
      }
    )
  }, []);

  return (
    <div>Downloading...</div>
  )
}

export default Download;